import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLodash from 'vue-lodash'
import './assets/scss/main.scss'

Vue.use(VueLodash)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['login', 'home', 'homeSubPage', 'creatorPageUser', 'forgotPassword', 'setPassword', 'yourText', 'featureDetail', 'featureDetailLive'];
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next({
      path: '/login',
      query: { returnUrl: to.path }
    });
  }

  next();
})

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
